/**
 * Composable for loading Sizebay size recommendation script
 *
 * Dynamically loads the Sizebay script based on configuration
 *
 * @returns {Promise<Object | undefined>} Script loading result or undefined if no Sizebay ID is configured
 *
 * @description
 * - Retrieves Sizebay ID from runtime configuration
 * - Constructs Sizebay script URL
 * - Dynamically loads the script using useScript
 *
 * @example
 * // Load Sizebay script
 * const sizebayScript = await useSizebay()
 */
export const useSizebay = async () => {
  const config = useRuntimeConfig()
  const sizeBayId = config.public.sizebay

  // Return early if no Sizebay ID is configured
  if (!sizeBayId) return

  /**
   * Constructs the Sizebay script URL using the configured Sizebay ID
   * @type {string}
   */
  const sizebayScript: string = `https://static.sizebay.technology/${sizeBayId}/prescript.js`

  // Dynamically load the Sizebay script
  return useScript({
    src: sizebayScript,
  })
}
